import amplitude from 'amplitude-js';
import {
    CHAT_BUTTON_CLICKED,
    GET_CARD_SELECTED,
    RESUME_TRANSFER_CLICKED,
    TOP_UP_COMPLETED,
    TRY_VERIFICATION_AGAIN_CLICKED,
    VERIFY_IDENTITY_CLICKED,
} from 'apps/promo/constants/amplitude/AmplitudeEvents';
import { ARTICLE, FROM, PAYMENT_METHOD_AMPLITUDE, SECTION } from 'apps/promo/constants/amplitude/AmplitudeParamName';
import { ACCOUNT, BUSINESS, CARD, DRAFT, INDIVIDUAL, NEW, RECIPIENT, REPEAT, SELF } from 'apps/promo/constants/amplitude/AmplitudeParamValues';
import { toLowerCase } from 'apps/promo/helpers/utils';

export const AMPLITUDE_API_KEY = 'dc4e90956cf073ddd42b5651524b0a28';

export const setAmplitudeNoopInstance = () => {
    amplitude.getInstance = () => ({
        init: () => {},
        setOptOut: () => {},
        setUserId: () => {},
        setUserProperties: () => {},
        setVersionName: () => {},
        logEvent: () => {},
    });
};

export const providerCategories = {
    '-45': 'swift',
    '-43': 'sofort',
    '-130': 'klarna',
    '-42': 'weixin_china',
    '-41': 'ach',
    '-40': 'mobile_number',
    '-39': 'flinks',
    '-38': 'cash_delivery',
    '-36': 'trustly',
    '-35': 'plaid',
    '-90': 'plaid',
    '-34': 'uk_regular_bank_transfer',
    '-32': 'interac',
    '-105': 'interac',
    '-100': 'account',
    '-31': 'cash_payout',
    '-26': 'upi',
    '-21': 'apple',
    '-20': 'google',
    '-18': 'alipay',
    '-17': 'ewallet',
    '-16': 'account',
    '-13': 'account',
    '-10': 'card',
    '-49': 'giropay',
    '-30': 'global_account',
    '-44': 'ideal',
    '-52': 'blik',
    '-48': 'eps',
    '-54': 'mbway',
    '-70': 'cash_uniteller',
    7: 'p2p_pay',
    99: 'p2p_pay',
};

export const transactionMethods = {
    BANK_CARD: 'card',
    VISA_BANK_CARD: 'card',
    BANK_CARD_110: 'card',
    GT_GLOBAL_ACCOUNT: 'balance',
    BANK_ACCOUNT: 'account',
    USA_BANK_ACCOUNT: 'account',
    SWIFT: 'swift',
    CASH: 'cash_payout',
    HOME_DELIVERY: 'cash_delivery',
    WALLET: 'ewallet',
    CARD_VIA_PHONE: 'mobile_number',
    ALIPAY: 'alipay',
    FPS: 'fps',
    UPI: 'upi',
    INTERAC: 'interac',
    PEOPLE_TRUST_INTERAC: 'interac',
    CONTACT: 'mobile_number',
    WECHAT: 'weixin_china',
    BONUS: 'bonus',
    GOOGLE_PAY: 'google',
    APPLE_PAY: 'apple',
    FLINKS: 'flinks',
    TRUSTLY: 'trustly',
    TINK: 'tink',
    ACH: 'ach',
    SOFORT: 'sofort',
    KLARNA: 'klarna',
    GIROPAY: 'giropay',
    IDEAL: 'ideal',
    BLIK: 'blik',
    EPS: 'eps',
    MBWAY: 'mbway',
    GLOBAL_ACCOUNT: 'global_account',
    GLOBAL_SWIFT: 'global_swift',
    GLOBAL_CARD: 'global_card',
    CASH_UNITELLER: 'cash_uniteller',
    UNITELLER_MASTERCARD_BANK_CARD: 'card',
    SEPA: 'sepa',
    LIBRE_PAYSEND_LIVE: 'libre',
    REMITEE: 'remitee',
    OFAKIM: 'ofakim',
    LEAN: 'lean',
    MYBANK: 'mybank',
    MODULR: 'modulr',
    PLAID: 'plaid',
};

export const amplitudeLogout = () => {
    if (typeof window === 'undefined') {
        return;
    }
    const amp = typeof amplitude?.getInstance === 'function' ? amplitude.getInstance() : null;
    if (!amp || typeof amp.clearUserProperties !== 'function' || typeof amp.setUserId !== 'function' || typeof amp.regenerateDeviceId !== 'function') {
        return;
    }
    amp.clearUserProperties();
    amp.setUserId(null);
    amp.regenerateDeviceId();
};

// Global Account
export const amplitudeEventForGetCardFromCards = () => {
    amplitude.getInstance().logEvent(GET_CARD_SELECTED, {
        [FROM]: CARD,
    });
};

export const amplitudeEventForGetCardFromAccount = () => {
    amplitude.getInstance().logEvent(GET_CARD_SELECTED, {
        [FROM]: ACCOUNT,
    });
};

export const amplitudeEventForCompletedTopUp = (method) => {
    amplitude.getInstance().logEvent(TOP_UP_COMPLETED, {
        [PAYMENT_METHOD_AMPLITUDE]: method,
    });
};

export const getParamsForGlobalMethods = (sourcesArr) => {
    let paramArr = [];
    if (Array.isArray(sourcesArr) && sourcesArr.length > 0) {
        sourcesArr.forEach((source) => {
            if (source.id === 1001) {
                paramArr.push(transactionMethods.GLOBAL_SWIFT);
            } else if (source.id === 1002) {
                paramArr.push(transactionMethods.GLOBAL_CARD);
            }
        });
    }
    return paramArr;
};

export const getEventNameForDraftTransfer = (chequeExtra) => {
    if (chequeExtra.draftCompletedVerification) {
        return RESUME_TRANSFER_CLICKED;
    } else if (chequeExtra.draftOnfidoCheckError) {
        return TRY_VERIFICATION_AGAIN_CLICKED;
    } else if (chequeExtra.draftSkippedVerification) {
        return VERIFY_IDENTITY_CLICKED;
    } else if (chequeExtra.draftOnfidoTooManyAttempts) {
        return CHAT_BUTTON_CLICKED;
    }
};

export const getSubSourceName = (sourceCodeToValue, sources) => {
    if (sources && Array.isArray(sources) && sources.length > 0) {
        const subSource = sources.find((source) => source?.code === sourceCodeToValue);
        return subSource?.sourceName;
    }
    return null;
};

export const getPaymentFlow = (draft, repeat, fromSend) => {
    if (fromSend) {
        return RECIPIENT;
    } else if (repeat) {
        if (draft) {
            return DRAFT;
        } else {
            return REPEAT;
        }
    } else {
        return NEW;
    }
};

export const getAmplitudeHandler = (eventName, options) => {
    return () => {
        amplitude.getInstance().logEvent(eventName, options);
    };
};

export const getFullCountryName = (currentCountryCode, allCountries) => {
    const currentCountry = allCountries.find(({ code }) => code === currentCountryCode);
    return currentCountry?.nameEn;
};

export const getRecipientTypeParam = (recipeType) => {
    let recipientType = undefined;
    if (recipeType) {
        const type = toLowerCase(recipeType);
        if (type === 'self') {
            recipientType = SELF;
        } else if (type === 'other') {
            recipientType = INDIVIDUAL;
        } else if (type === 'business') {
            recipientType = BUSINESS;
        }
    }
    return recipientType;
};

export const getSofParamName = (val) => {
    switch (val) {
        case 'Business Revenue':
            return 'business';
        case 'Family Support':
            return 'family';
        case 'Sale Profit (Property/Car)':
            return 'property';
        default:
            return toLowerCase(val);
    }
};

export const getHelpMobileIdParams = (url) => {
    const sectionMatch = url.match(/\/section\/(\d+)/);
    const articleMatch = url.match(/\/article\/(\d+)/);

    return {
        [SECTION]: sectionMatch ? sectionMatch[1] : null,
        [ARTICLE]: articleMatch ? articleMatch[1] : null,
    };
};

export const getTransferCountParam = () => {
    if (!__isBrowser__) return;
    const storedValue = localStorage.getItem('transferCount');
    if (storedValue === 'no_value') return;
    const current = Number(storedValue) || 0;
    const nextValue = current + 1;

    const result = String(nextValue);
    if (nextValue < 6) {
        localStorage.setItem('transferCount', result);
        return result;
    } else {
        localStorage.setItem('transferCount', 'no_value');
        return null;
    }
};
